module.exports = __webpack_public_path__ + "static/image_17_thumb-a9e2d08eeffa0a1e85977062d1305ee9.jpg";